import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Center, Spinner, VStack } from '@chakra-ui/react';
import { ArticleListNavCard } from '@src/components/sco/Education/ArticleListNav/ArticleListNavCard';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { gql } from '@src/lib/gql';
import React from 'react';
type ArticleListNavProps = {
  articleType: string;
  typeSlug?: string;
  typeTitle?: string;
  keywords?: string;
  termSlugs?: string[];
};
export const ArticleListNav = props => {
  const $ = _c(22);
  const educationContext = useEducationContext();
  let t0;
  if ($[0] !== props.keywords || $[1] !== props.termSlugs?.length) {
    t0 = props.keywords || props.termSlugs?.length > 0 ? ArticleListNav.queries.articlesFiltered() : ArticleListNav.queries.articles();
    $[0] = props.keywords;
    $[1] = props.termSlugs?.length;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== props.termSlugs) {
    t1 = props.termSlugs || [];
    $[3] = props.termSlugs;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = props.articleType || "ExpertAdvice";
  let t3;
  if ($[5] !== educationContext.activeKeywords || $[6] !== t1 || $[7] !== t2) {
    t3 = {
      variables: {
        keywords: educationContext.activeKeywords,
        termSlugs: t1,
        type: t2
      }
    };
    $[5] = educationContext.activeKeywords;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const query = useQuery(t0, t3);
  let t4;
  if ($[9] !== query.loading) {
    t4 = query.loading && <Center padding="1em"><Spinner /></Center>;
    $[9] = query.loading;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== query.error) {
    t5 = query.error && <p>{"Error: "}{query.error.message}</p>;
    $[11] = query.error;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== props.typeSlug || $[14] !== query.data?.articles) {
    t6 = query.data?.articles.map(article => <ArticleListNavCard key={article.id} article={article} id={article.id} slug={article.slug} typeSlug={props.typeSlug} />);
    $[13] = props.typeSlug;
    $[14] = query.data?.articles;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t6) {
    t7 = <VStack align="flex-start" gap={4} height="full" overflowY="scroll" paddingY={4} width="full">{t6}</VStack>;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t7) {
    t8 = <VStack align="flex-start" gap={2} height="full" minHeight="50vh" overflow="hidden" width="full">{t4}{t5}{t7}</VStack>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
ArticleListNav.queries = {
  articles: () => gql`
    query ($type: ArticleType!) {
      articles(where: { type: $type }, orderBy: publishedAt_DESC) {
        id
        title
        slug
        featuredImage {
          id
          url(transformation: { image: { resize: { fit: max, width: 400 } } })
        }
      }
    }
  `,
  articlesFiltered: () => gql`
    query ($keywords: String, $termSlugs: [String], $type: ArticleType!) {
      articles(
        where: { type: $type, OR: [{ _search: $keywords }, { terms_some: { slug_in: $termSlugs } }] }
        orderBy: publishedAt_DESC
      ) {
        id
        title
        slug
        featuredImage {
          id
          url(transformation: { image: { resize: { fit: max, width: 400 } } })
        }
      }
    }
  `
};